export const MAIN = {
  landing: "/bnr/landing",
  aboutUs: "/bnr/about-us",
  contactUs: "/bnr/contact-us",
  terms: "/bnr/terms-conditions",
  privacy: "/bnr/privacy-policy",
};

export const AUTH = {
  login: "/auth/login",
  forgotPassword: "/auth/forgot-password",
  signup: "/auth/signup",
  category: "/auth/account-type",
  clientProfile: "/auth/client-profile",
  freelancerProfile: "/auth/freelancer-profile",
};

export const FREELANCER = {
  dashboard: "/freelancer/dashboard",
  notifications: "/freelancer/notifications",
  chat: "/freelancer/chat",
  submitProposal: "/freelancer/submitProposal",
  profile: "/freelancer/profile",
  hire: "/freelancer/hire",
  connects: "/freelancer/connects",
  transactionHistory: "/freelancer/transaction-history",
  myJobs: "/freelancer/my-jobs",
  myProposals: "/freelancer/my-proposals",
  viewCourse: (id) => `/freelancer/course/${id}`,
  viewLecture: (id) => `/freelancer/lectures/${id}`,
  viewProposal: (id) => `/freelancer/view-proposal/${id}`,
  viewProposals: "/freelancer/view-proposals",
  courses: "/freelancer/courses",
  aboutUs: "/freelancer/about-us",
  contactUs: "/freelancer/contact-us",
  terms: "/freelancer/terms-conditions",
  privacy: "/freelancer/privacy-policy",
  disputeResolution: "/freelancer/disputes",
  fileAComplain: (id) => `/freelancer/file-a-complain/${id}`,
};

export const CLIENT = {
  home: "/client/home",
  notifications: "/client/notifications",
  chat: "/client/chat",
  jobPost: "/client/all-jobs",
  reviewProposals: (id) => `/client/review-proposals/${id}`,
  viewJob: "/client/view-job",
  jobDetails: "/client/job-details",
  clientFreelancer: (id) => `/client/freelancer/${id}`,
  inviteFreelancer: (id) => `/client/invite-freelancer/${id}`,
  talents: "/client/talents",
  // discover: "/client/discover",
  profile: "/client/profile",
  viewProposal: (id) => `/client/view-proposal/${id}`,
  disputeResolution: "/client/disputes",
  fileAComplain: (id) => `/client/file-a-complain/${id}`,
};
